import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import AdminProfileDropdown from "../admin/AdminProfileDropdown";
import MachineDropdown from "../machine/MachineDropdown";
import CustomerDropdown from "../customer/CustomerDropdown";
import DealerDropdown from "../dealer/DealerDropdown";
import SchemeDropdown from "../scheme/SchemeDropdown";
import ApplyDropdown from "../apply/ApplyDropdown";
import TrackerDropdown from "../tracker/TrackerDropdown";
import ManufacturerDropdown from "../manufacturer/ManufacturerDropdown";
// import logoImage from "../../assets/Location.png";
import logoImage from "../../assets/tes-logo.png";

const Root = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
}));

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const Logo = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

const NavLinks = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  "& > *": {
    marginRight: theme.spacing(2),
    color: "white",
    textDecoration: "none",
  },
}));

const Content = styled("div")(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  marginTop: theme.spacing(8),
}));

const Layout = ({ children }) => {
  const role = localStorage.getItem("role");

  return (
    <Root>
      <StyledAppBar position="fixed">
        <StyledToolbar>
          <img src={logoImage} alt="Logo" style={{ height: "34px" }} />
          <Logo variant="h6">Tech Exponent System Tracker</Logo>
          <NavLinks>
            <Button color="inherit" component={Link} to="/dashboard">
              Dashboard
            </Button>

            {/* Show only for ADMIN */}
            {role === "ADMIN" && (
              <>
                <ManufacturerDropdown />
                <CustomerDropdown />
                <SchemeDropdown />
                <ApplyDropdown />
                <TrackerDropdown />
              </>
            )}

            {/* Shared between ADMIN and MANUFACTURER */}
            {(role === "ADMIN" || role === "MANUFACTURER") && (
              <>
                <MachineDropdown />
                <DealerDropdown />
              </>
            )}
          </NavLinks>
          <AdminProfileDropdown />
        </StyledToolbar>
      </StyledAppBar>
      <Content>{children}</Content>
    </Root>
  );
};

export default Layout;
